import { render, staticRenderFns } from "./TeamsDaily.vue?vue&type=template&id=2a552cb9&"
import script from "./TeamsDaily.vue?vue&type=script&lang=ts&"
export * from "./TeamsDaily.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports